import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ConfirmationService, Message, SelectItem } from 'primeng/api';
import { forkJoin } from 'rxjs';
import { Bandeira } from 'src/app/admihair/api/dto/bandeira';
import { Empresa } from 'src/app/admihair/api/dto/empresa';
import { MeioPagamentoTributario } from 'src/app/admihair/api/dto/meio-pagamento-tributario';
import { Operacao } from 'src/app/admihair/api/dto/operacao';
import { ParcelaPagamento } from 'src/app/admihair/api/dto/parcela-pagamento';
import { TipoPagamento } from 'src/app/admihair/api/dto/tipo-pagamento';
import { BandeiraService } from 'src/app/admihair/service/bandeira.service';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { MeioPagamentoTributarioService } from 'src/app/admihair/service/meio-pagamento-tributario.service';
import { OperacaoFinanceiraService } from 'src/app/admihair/service/operacao-financeira.service';
import { ParcelaPagamentoService } from 'src/app/admihair/service/parcela-pagamento.service';
import { TipoPagamentoService } from 'src/app/admihair/service/tipo-pagamento.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { AuthUtil } from 'src/app/admihair/util/auth-util';

@Component({
  selector: 'app-tipo-pagamento-editar',
  templateUrl: './tipo-pagamento-editar.component.html',
  styleUrls: ['./tipo-pagamento-editar.component.scss']
})
export class TipoPagamentoEditarComponent implements OnInit {

  permissaoEditar: boolean = false;
  id?: number;
  messages: Message[] = [];
  messagemVisivel: boolean = false;
  empresaSelecionada?: Empresa;
  tipoPagamento: TipoPagamento = {};
  operacoes: SelectItem[] = [];
  transacoes: string[] = ['AJUSTE', 'A VISTA', 'DEBITO', 'CREDITO'];
  bandeiras: string[] = [];
  taxaAntecipacao: number = 0;
  parcelas: ParcelaPagamento[] = [];
  qtdParcelas: number = 0;
  progressoRequisicao: boolean = false;
  descAtiva: boolean = false;
  iconeLock: boolean = true;
  itensDescAtiva: boolean = true;
  itensDescMudou: boolean = false;
  modoEdicao: boolean = true;

  exibirSpinner: boolean = false;
  @ViewChild('f') form?: NgForm;


  meiosPagamento: MeioPagamentoTributario[] = [];

  constructor(private activatedRouter: ActivatedRoute,
    private tipoPagamentoService: TipoPagamentoService,
    private meioPagamentoService: MeioPagamentoTributarioService,
    private operacaoService: OperacaoFinanceiraService,
    private parcelaPagamentoService: ParcelaPagamentoService,
    private bandeiraService: BandeiraService,
    private confirmationService: ConfirmationService,
    private utilStorageService: UtilStorageService,
    private erroService: ErroService) { }


  ngOnInit(): void {
    this.exibirSpinner = true;
    this.permissaoEditar = this.verificarPermissao('PERM_EDITAR_TIPO_DE_PAGAMENTO');
    this.empresaSelecionada = this.utilStorageService.getEmpresa();
    this.carregarIdTipoPagamento();
    if (this.permissaoEditar) {
      this.carregarDados();
    }
  }

  carregarIdTipoPagamento() {
    const idParam = this.activatedRouter.snapshot.paramMap.get('id');
    if (idParam) {
      this.id = parseInt(idParam);
    }

  }

  carregarDados() {
    forkJoin<[Operacao[], Bandeira[],MeioPagamentoTributario[], TipoPagamento]>([
      this.operacaoService.listarPorEmpresaESituacao(this.empresaSelecionada?.id, true),
      this.bandeiraService.listar(),
      this.meioPagamentoService.listarAplicaveis(),
      this.tipoPagamentoService.buscarPorId(this.id)
    ]).subscribe({
      next: ([operacoes, bandeiras, tributarios, tipoPagamento]) => {

        this.mapearOperacoes(operacoes);
        this.mapearBandeiras(bandeiras);
        this.meiosPagamento = tributarios;
        this.tipoPagamento = tipoPagamento;
        this.buscarParcelas();
      },
      error: (err: any) => {
        this.exibirSpinner = false;
        this.messages = this.erroService.handleErro(err);
        this.messagemVisivel = true;
        this.rolarTela();
      }
    })
  }

  mapearOperacoes(listaOperacoes: Operacao[]) {
    this.operacoes = listaOperacoes.map(item =>
      ({ label: `${item.descricao} - ${item.conta?.descricao}`, value: item }));
  }

  mapearBandeiras(listaBandeiras: Bandeira[]) {
    this.bandeiras = listaBandeiras.map(bandeira => bandeira.descricaoBandeira);
  }

  buscarParcelas() {
    this.parcelaPagamentoService.listarPorTipoPagamento(this.tipoPagamento.id).subscribe({
      next: (data: ParcelaPagamento[]) => {
        this.parcelas = data;
        this.exibirSpinner = false;
      },
      error: (err: any) => {
        this.exibirSpinner = false;
        this.messages = this.erroService.handleErro(err);
        this.messagemVisivel = true;
        this.rolarTela();
      }
    })
  }

  atualizar() {
    this.progressoRequisicao = true;
    if (this.itensDescMudou) {
      this.tipoPagamento.descricao = this.formatarDescricao(this.tipoPagamento);
    }
    

    this.tipoPagamentoService.atualizar(this.tipoPagamento, this.id).subscribe({
      next: () => {
        this.atualizarParcelas(this.tipoPagamento);
        this.messages = this.erroService.handleSuccess();
        this.messagemVisivel = true;
        this.progressoRequisicao = false;
        this.rolarTela();
      },
      error: (err: any) => {
        this.messages = this.erroService.handleErro(err);
        this.messagemVisivel = true;
        this.progressoRequisicao = false;
        this.rolarTela();
      }
    });

  }

  atualizarParcelas(tipoPagamento: TipoPagamento) {
    for (let parcela of this.parcelas) {
      parcela.tipoPagamento = tipoPagamento;
      if (parcela.id) {
        this.parcelaPagamentoService.atualizar(parcela, parcela.id).subscribe({
          next: (data: ParcelaPagamento) => {
          },
          error: (err: any) => {
            this.messages = this.erroService.handleErro(err);
            this.messagemVisivel = true;
            this.rolarTela();
          }
        });
      } else {
        this.parcelaPagamentoService.salvar(parcela).subscribe({
          next: (data: ParcelaPagamento) => {

          },
          error: (err: any) => {
            this.messages = this.erroService.handleErro(err);
            this.messagemVisivel = true;
            this.rolarTela();
          }
        })
      }
    }
  }

  gerarParcelas() {
    const inicioParcelas = this.parcelas.length === 0 ?
      1 : this.parcelas.length + 1;
    for (let i = inicioParcelas; i < inicioParcelas + this.qtdParcelas; i++) {
      this.parcelas.push(
        {
          quantidadeParcelas: i,
          prazo: i * 30,
          descontoFinanceira: 0,
          status: true
        }
      );
    }
    this.qtdParcelas = 0;
  }

  excluirParcela(item?: ParcelaPagamento) {
    console.log(item)
    if (item?.id) {
      this.confirmationService.confirm({
        message: 'Tem certeza que seja excluir?',
        header: 'Parcela já salva',
        acceptLabel: 'Sim',
        rejectLabel: 'Não',
        icon: 'pi pi-info-circle',
        accept: () => {
          this.parcelaPagamentoService.excluir(item.id).subscribe({
            next: () => {
              this.buscarParcelas();
              this.messages = this.erroService.handleSuccess();
              this.messagemVisivel = true;
              this.rolarTela();
            },
            error: (err: any) => {
              this.messages = this.erroService.handleErro(err);
              this.messagemVisivel = true;
              this.rolarTela();
            }
          });
        }
      });
    } else {
      if (item) {
        const posicao = this.parcelas.indexOf(item);
        this.parcelas.splice(posicao, 1);
        this.messages = this.erroService.handleSuccess();
        this.messagemVisivel = true;
        this.rolarTela();
      }
    }

  }

  verificarPermissao(nome: string): boolean {
    return AuthUtil.verificarPermissao(nome);
  }

  ativaDescricao() {
    this.iconeLock = !this.iconeLock;
    this.descAtiva = !this.descAtiva;
    this.itensDescAtiva = false;
  }

  mudouDescricao() {
    this.itensDescMudou = true;
  }

  formatarDescricao(tipo: TipoPagamento): string {
    return `${tipo.bandeira} ${tipo.transacao} ${tipo.operacao?.descricao}`;
  }

  limparFormulario() {
    this.form?.reset();
  }

  ocultarMensagem() {
    if (this.messagemVisivel) {
      this.messagemVisivel = false;
    }
  }
  rolarTela() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }

}
